import { Flow } from 'signup-constants/Flow';
import styled, { keyframes, css } from 'styled-components';
import { Step } from 'signup-constants/Step';
import { AnimatedStep } from 'signup-components/styles/Animations.styles';
export const ExtendedAnimatedStep = styled(AnimatedStep).withConfig({
  displayName: "Animationsstyles__ExtendedAnimatedStep",
  componentId: "v2wyk-0"
})(["", ""], props => props.$flowKey === Flow.FbCrm && props.$currentStep === Step.LandingPage && `padding-top: 40px;`);
const slideInDown = keyframes(["from{opacity:0;transform:translateY(-8px);}to{opacity:1;transform:translateY(0);}"]);
export const AnimatedHelperTextWrapper = styled.div.withConfig({
  displayName: "Animationsstyles__AnimatedHelperTextWrapper",
  componentId: "v2wyk-1"
})(["", ""], props => props.isSidePanel && css(["animation:", " 0.3s ease-out;"], slideInDown));